import { render, staticRenderFns } from "./apply-history.vue?vue&type=template&id=95d8abee&scoped=true"
import script from "./apply-history.vue?vue&type=script&lang=ts"
export * from "./apply-history.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d8abee",
  null
  
)

export default component.exports